/** The props of the train results, shared by its looks (TrainResults.tsx, TrainSingle.tsx). */
import { z } from 'zod';
import { trainSchema } from '../session';

export const RESULTS_PER_PAGE = 3; // backend/backend/config/settings.py: UXSettings.results_per_page

export const trainResultsSchema = z.object({
  trains: z.array(trainSchema),
  page: z.number().int().min(0).default(0),
  /** 1-based, like the backend's `selected_idx`. */
  selectedIdx: z.number().nullable().default(null),
});

export type TrainResultsProps = z.infer<typeof trainResultsSchema>;
